import { render, staticRenderFns } from "./NewIssueForm.vue?vue&type=template&id=7d4bb374&"
import script from "./NewIssueForm.vue?vue&type=script&lang=js&"
export * from "./NewIssueForm.vue?vue&type=script&lang=js&"
import style0 from "./NewIssueForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports